import { useCallback } from "react";

import { useLazyDownloadCompetitorsQuery } from "../../../redux/organization/organization.api";
import { OrganizationExportRequest } from "../../Contacts/schema/contact-organization.types";
import { saveFileFromBlob } from "../../Contacts/utils/downloadFile";

interface UseCompetitorsExportOptions {
	getSelectionPayload: () => OrganizationExportRequest;
	onError: () => void;
}

/**
 * Exports the current competitor selection as a date-stamped .xlsx download.
 */
export const useCompetitorsExport = ({
	getSelectionPayload,
	onError,
}: UseCompetitorsExportOptions) => {
	const [downloadCompetitors, { isFetching: isExportLoading }] = useLazyDownloadCompetitorsQuery();

	const handleExport = useCallback(async () => {
		try {
			const fileName = `competitors-export-${new Date().toISOString().slice(0, 10)}.xlsx`;
			const downloadPromise = downloadCompetitors(getSelectionPayload()).unwrap();

			await saveFileFromBlob(downloadPromise, fileName, {
				description: "Excel File",
				mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				extension: "xlsx",
			});
		} catch (error) {
			console.error(error);
			onError();
		}
	}, [downloadCompetitors, getSelectionPayload, onError]);

	return { handleExport, isExportLoading };
};
